import { Vue, Prop, Component } from 'vue-property-decorator';
import { appConfigService } from '@/providers/services/app/app-config';
import { groupsApi } from '@/providers/apis/groups/groups';
import { sessionService } from '@/providers/services/auth/session';
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker';
import { getMonthAndYear } from '@/utils/utils';
import { MonthPicker } from 'vue-month-picker';
import { MonthPickerInput } from 'vue-month-picker';
@Component({
    name: 'summary-pullup-header',
    components: {
        'date-range-picker': DateRangePicker,
        MonthPicker,
        MonthPickerInput,
    },
})

export default class SumaryPullupHeader extends Vue {

    private get session() {
        return sessionService.getSession() || {};
    }

    public activeTenantId: any;

    @Prop()
    public isPerformanceSummary: any;

    public classIds: any;

    public startDate: any = {
        from_year: moment().year() - 1,
        to_year: moment().year(),
        from_month: moment().month() + 1,
        to_month: moment().month() + 1,
    };

    public selectedItem: any = {};

    public filterMapping: any = {};

    public isLoading: boolean = false;

    public groupHierarchyLevels: any = [];

    public aclList: any;

    public dropdownData: any = [];

    @Prop()
    public paramsPayload: any;

    private startMonth: any = new Date() ;

    private endMonth: any = null;

    private levelIndex: number = 0;

    public created() {
        this.loadData();
    }

    public handleRangeSelection() {
        this.$emit('handleRangeSelection', this.startDate);
    }

    public onClearFilter(level: any, levelIndex: any) {
        const levelsSequence = this.groupHierarchyLevels.map((item: any) => item.type);
        const activeLevelIndex = levelsSequence.indexOf(level.type);
        const activeLevel = this.groupHierarchyLevels[activeLevelIndex - 1] || {};
        this.$emit('onChangeFilter', activeLevel.type, this.filterMapping[activeLevel.type] || []);
        const filterLevels = levelsSequence.slice(activeLevelIndex);
        this.levelIndex = levelIndex;
        filterLevels.forEach((item: any) => {
            this.filterMapping[item] = null;
        });
    }

    public openMonthPicker(refElement: any) {
        (this.$refs[refElement] as any).monthPickerVisible = true;
    }

    public onClickHierarchyLevel(level: any, index: any = null) {
        this.isLoading = true;
        const aclByType = this.aclList.aclByType;
        let groups: any = [];
        if (level.type !== 'class') {
            const params = {
                type: level.type,
                tenantId : this.activeTenantId,
            };
            groupsApi.fetchGroupedHierarchyMapping(params).then((groupData: any) => {
                const filteredAclData = aclByType[level.type].map((item: any) => {
                    groups = [...groups, ...item.groups];
                });
                level.listItems = [];
                const activeItem = this.selectedItem[level.type] || [0];
                activeItem.map((element: any) => {
                    if (groupData[element]) {
                        const groupFilterItem = groupData[element].cohortList.filter(
                            (item: any) => groups.includes(item.id));
                        level.listItems = level.listItems.concat(groupFilterItem);
                    }
                });
                const prevLevel = level.sequence - 1;
                let levelSeq: any ;
                if (prevLevel !== 0) {
                    levelSeq = this.groupHierarchyLevels.filter((item: any) => {
                        return item.sequence === prevLevel;
                    });
                }
                if (levelSeq && this.filterMapping && this.filterMapping[levelSeq[0].type]) {
                    level.listItems = level.listItems.filter((item: any) => {
                        return this.filterMapping[levelSeq[0].type].includes(item.parentId);
                    });
                }
                this.$set(level, 'listItems', level.listItems);
                if (index !== null) {
                    this.onSelectItem(level.listItems[0], index);
                }
                this.isLoading = false;
            });
        } else {
            this.isLoading = false;
        }
        if (level.type === 'class') {
            this.isLoading = true;
            const session: any = this.session;
            const params = {
                group_ids: this.classIds.join(','),
                tenants: this.activeTenantId
                ? this.activeTenantId : session && session.tenant
                ? session.tenant.tenant_id : '',
            };
            groupsApi.fetchClassData(params).then((response) => {
                this.groupHierarchyLevels.forEach((element: any) => {
                    if (element.type === 'class') {
                        this.$set(element, 'listItems', response);
                    }
                });
                this.isLoading = false;
            });
        }
    }

    public onSelectItem(item: any, index: any) {
        const nextHierarchy = this.groupHierarchyLevels[index + 1];
        const previousHierarchy = this.groupHierarchyLevels[index - 1];
        let activeLevel = this.groupHierarchyLevels[index];
        if (nextHierarchy) {
           const selectedHierarchy = this.selectedItem;
           if (selectedHierarchy[nextHierarchy.type]) {
               if (item.id && !selectedHierarchy[nextHierarchy.type].includes(item.id)) {
                selectedHierarchy[nextHierarchy.type].push(item.id);
               }
           } else {
               selectedHierarchy[nextHierarchy.type] = [item.id];
           }
        }
        if (!this.filterMapping[activeLevel.type]) {
            this.filterMapping[activeLevel.type] = [];
        }
        if (this.filterMapping[activeLevel.type].includes(item.id)) {
            this.filterMapping[activeLevel.type] = this.filterMapping[activeLevel.type].filter(
                (activeId: any) => activeId !== item.id);
            if (!this.filterMapping[activeLevel.type].length && previousHierarchy) {
                    activeLevel = previousHierarchy;
                }
        } else {
            this.filterMapping[activeLevel.type].push(item.id);
        }

        const classIds: any = [];
        if (nextHierarchy && nextHierarchy.type === 'class') {
            this.filterMapping[activeLevel.type].map((classItem: any) => {
                classIds.push(classItem);
            });
            this.classIds = classIds;
        }

        this.levelIndex = index + 1;
        if (item.type !== 'class' && item.type !== 'school') {
            if (activeLevel.type !== item.type) {
                this.levelIndex = index;
                const selectedItem = this.groupHierarchyLevels[index];
                this.onClearFilter(selectedItem, this.levelIndex);
            } else {
            this.onClearFilter(nextHierarchy, this.levelIndex);
            }
        } else {
            this.$emit('onChangeFilter', activeLevel.type, this.filterMapping[activeLevel.type]);
        }
    }

    private async loadData() {
        const session: any = this.session;
        const activeTenant = this.$access.getGroupHierarchyTenants;
        this.activeTenantId = JSON.parse(activeTenant).id;
        const params = {
            userId: session.user_id,
            tenantId: this.activeTenantId ? this.activeTenantId : session.tenant.tenant_id,
        };
        await groupsApi.fetchUserACL(params).then((groupAcl) => {this.aclList = groupAcl; });
        this.groupHierarchyLevels = appConfigService.getUserGroupAccessLevel() || [];
        const level = this.groupHierarchyLevels[0];
        this.groupHierarchyLevels.forEach((item: any) => {
            this.$set(item, 'listItems', []);
        });
        if (this.isPerformanceSummary) {
            this.groupHierarchyLevels.pop();
            this.onClickHierarchyLevel(level, 0);
        }
    }

    private onChangeStartDate(date: any, isStartDate: boolean = false) {
        if (date.month) {
            const month = moment(date).format('MM');
            const year = moment(date.from).year();
            this.startDate[isStartDate ? 'from_month' : 'to_month'] = date.monthIndex;
            this.startDate[isStartDate ? 'from_year' : 'to_year'] = year;
        }
    }
}
